import React, { FC } from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { VideoCards } from "./components/video-cards/VideoCards";
import { VideoCardProps } from "./components/video-cards/components/video-card/VideoCard";

type Props = {
  videos: Pick<VideoCardProps, "title" | "excerpt" | "youtubeId">[];
  file: string;
};

export const PressRelease: FC<Props> = ({ videos, file }) => {
  const { t } = useTranslation("t_blog");

  return (
    <section className={classNames("pb-5 pt-20", "md:pt-[140px]")}>
      <VideoCards items={videos} />
      {file && (
        <div className="mt-md-7 mt-5 text-center">
          <a
            download
            className="btn btn-primary"
            href={file}
            target="_blank"
            rel="noreferrer"
          >
            {t("download_press_release_btn")}
          </a>
        </div>
      )}
    </section>
  );
};
